/* eslint-disable quote-props */
const messages = {
	_: {
		id: 'ID',
		name: 'Nama',
		email: 'Email',
		phone: 'Telepon',
		point: 'Point',
		date: 'Tanggal',
		title: 'Judul',
		description: 'Deskripsi',
		province: 'Provinsi',
		city: 'Kota',
		subdistrict: 'Kecamatan',
		receiptNumber: 'No. Resi',
		coupon: 'Kupon',
		bump: 'Bump',
		productName: 'Nama Produk',
		qty: 'Quantity',
		status: 'Status',
		handledBy: 'Ditugaskan untuk',
		processingAt: 'Processing At',
		completedAt: 'Completed At',
		grossRevenue: 'Gross Revenue',
		paymentInfo: 'Informasi Pembayaran',
		readMore: 'Selengkapnya',
		tutorials: 'Tutorial',
		fullname: 'Nama Lengkap',
		phoneNumber: 'No. Telepon',
		language: 'Bahasa',
		cogs: 'COGS',
		paymentStatus: 'Status Pembayaran',
		checkoutPageName: 'Checkout Page Name',
		customFields: 'Custom Fields',
		tags: 'Tags',
		categories: 'Kategori',
		processingDate: 'Processing Date',
		processingDateSince: 'Date Since',
		processingDateUntil: 'Date Until',
		completedDate: 'Completed Date',
		completedDateSince: 'Date Since',
		completedDateUntil: 'Date Until',
		shippingInfo: 'Shipping Info',
		variations: 'Variasi',
		tickets: 'Tiket Bantuan',
		createCase: 'Buat Kasus',
		optional: 'Opsional',
		action: {
			edit: 'Ubah',
			detail: 'Lihat Detail',
		},
		courier: 'Kurir',
		shippingCost: 'Ongkir',
		price: 'Harga',
		hideCourier: 'Sembunyikan Label Kurir',
		cancel: 'Batal',
		close: 'Tutup',
	},
	global: {
		viewContactDetails: 'Lihat Detail Kontak',
		contact: '{count} Kontak',
		payment: '0 Payment | 1 Payment | {count} Payment',
		resellerRewards: '0 Reward | 1 Reward | {count} Rewards',
		resellerTiers: '0 Tier | 1 Tier | {count} Tiers',
		expenses: '0 Expenses | 1 Expenses | {count} Expenses',
		selected: 'Terpilih',
		delete: 'Hapus',
		export: 'Export ke CSV',
		filter: 'Filter',
		customizeColumn: 'Kustomisasi Kolom',
		searchPlaceholder: 'Cari..',
		cancel: 'Batal',
		close: 'Tutup',
		apply: 'Terapkan',
		applyFilter: 'Terapkan Filter',
		submit: 'Submit',
		save: 'Simpan',
		setTag: 'Set Tag',
		maxSelectedTag: 'Max Selected Tag',
		actions: 'Aksi',
		search: 'Cari',
		orders: '0 Order | 1 Order | {count} Orders',
		pickupSupport: 'Bantuan Pickup',
	},
	menu: {
		dashboard: 'Dashboard',
		dropship: 'Dropship',
		products: 'Produk',
		submissions: 'Submisi',
		orders: 'Order',
		coupons: 'Kupon',
		tutorials: 'Tutorial',
		createProduct: 'Tambah Produk',
		admin: 'Admin Area',
		addons: 'Add-Ons',
		appStore: 'App Store',
		apps: 'Apps',
		bonus: 'Bonus',
		myProfile: 'Profil Saya',
		profile: 'Profil',
		settings: 'Pengaturan',
		support: 'Bantuan',
		signout: 'Keluar',
		changePlan: 'Langganan',
		helpCenter: 'Pusat Bantuan',
		payments: 'Pembayaran',
		members: 'Anggota Tim',
		reports: 'Laporan',
		contacts: 'Kontak',
		expenses: 'Pengeluaran',
		inventory: 'Inventaris',
		others: 'Lainnya',
		shipments: 'Pengiriman',
		resellers: 'Reseller',
		billings: 'Tagihan',
		tickets: 'Tiket Bantuan',
	},
	pc: {
		step: {
			product: 'Produk',
			checkoutPage: 'Halaman Checkout',
			successPage: 'Halaman Sukses',
			done: 'Selesai',
		},
	},
	settings: {
		stock: {
			deductionDesc: 'Pada saat kapan stok produk berkurang',
			restoreDesc: 'Pada saat kapan stok produk dikembalikan',
		},
		shipping: {
			autoPickup: 'Ubah Status Otomatis Ketika Pickup',
			autoDelivered: 'Ubah Status Otomatis Ketika Terkirim',
			requestPickupDesc: 'Ubah status otomatis ketika status barang dalam permintaan pickup',
			deliveredStatusDesc: 'Ubah status otomatis ketika status barang sudah dikirim',
		},
	},
	contact: {
		title: 'Kontak',
		list: 'List Kontak',
		detail: 'Detail Kontak',
		create: 'Tambah Kontak',
		update: 'Perbaharui Kontak',
		reminder: {
			title: 'Kontak Pengingat',
			link: 'Pengingat',
			create: 'Tambah Pengingat',
		},
		deleteTitle: 'Hapus Kontak',
		tag: 'Tags',
		tagCreate: 'Tambah Tag',
		setTag: 'Atur Tag',
		name: 'Nama',
		email: 'Email',
		emailTo: 'Kepada',
		emailFrom: 'Dari',
		emailSubject: 'Judul',
		sendEmail: 'Kirim',
		emptyEmailIntegrate:
			'Perbaharui email di kontak ini untuk mengaktifkan fotur kirim email.',
		note: 'Catatan',
		createNote: 'Buat Catatan',
		whatsapp: 'Whatsapp',
		sendWa: 'Kirim Whatsapp',
		whatsappIntegrate: 'Integrasi WhatsApp Gateway',
		emptyWaIntegrate:
			'Integrasikan Whatsapp Gateway Account anda untuk mengaktifkan fitur kirim Whatsapp',
		sms: 'SMS',
		sendSms: 'Kirim SMS',
		emptySMSIntegrate:
			'Integrasikan SMS gateway anda untuk mengaktifkan fitur kirim SMS',
		smsIntegrate: 'Integrasi SMS Gateway',
		phone: 'No Handphone',
		phoneTabLabel: 'Telepon',
		callPhone: 'Buat Panggilan',
		phoneCallInstruction:
			'Use this Phone Call feature directly from your mobile phone',
		emptyPhone:
			'Perbaharui no handphone di kontak ini untuk melakukan panggilan telepon',
		scheduleDate: 'Tanggal',
		scheduleTitle: 'Judul',
		province: 'Provinsi',
		city: 'Kota/Kabupaten',
		subdistrict: 'Kecamatan',
		address: 'Alamat',
		date: 'Tanggal',
		lastContacted: 'Terakhir Dikontak',
		owner: 'Pemilik Kontak',
		detailAbout: 'Tentang',
		action: {
			edit: 'Ubah',
			detail: 'Lihat Detail',
		},
		export: 'Ekspor',
		empty: {
			data: 'Tidak Ada Kontak Data',
			filter: 'Anda Tidak Memiliki Kontak Di Rentang Tanggal Ini.',
		},
		deleteConfirm: 'Apakah anda yakin ingin menghapus',
		filterContact: 'Filter Kontak',
		buyerStatus: 'Status Pembeli',
		maxSelectedTag: 'Kamu hanya bisa memilih 5 tag untuk kontak ini',
		noPhoneCountry: 'No country phone prefix found',
		addModalTitle: 'Tambah Kontak Baru',
		editModalTitle: 'Edit Kontak',
		type: 'Tipe',
		validate: {
			name: 'Nama wajib diisi !',
			phone: 'Email atau NoHp wajib diisi !',
			email: 'Email atau NoHp wajib diisi !',
		},
		activity: 'Aktifitas',
		emptyAcitivity: 'Tidak Ada Akitifitas.',
		ltv: 'Lifetime Value (LTV)',
		ltvHistory: 'Lihat Jejak',
		ltvTitle: 'Jejak Lifetime Value',
		ltvOrderId: 'Id Pesanan',
		ltvProductName: 'Nama Produk',
		ltvDate: 'Tanggal',
		ltvTotalPrice: 'Total Harga',
		detailOther: 'Lainnya',
		metaBrowser: 'Browser',
		metaDeviceType: 'Tipe Device',
		metaOs: 'Sistem Operasi',
		metaReferrer: 'Perujuk',
		paidOrders: 'Pesanan Terbayarkan',
		product: 'Produk',
		contactOwner: 'Pemilik Kontak',
	},
	expenses: {
		title: 'Biaya',
		list: 'List Biaya',
		create: 'Tambah Pengeluaran',
		createAutomatic: '',
		name: 'Nama',
		amount: 'Amount',
		action: {
			edit: 'Edit',
			detail: 'Lihat Detail',
		},
		modalAddTitle: 'Tambah Pembiayaan Baru',
		modalEditTitle: 'Ubah Pembiayaan',
		addSourceTitle: 'Tambah Sumber Pembiayaan',
		editSourceTitle: 'Ubah Sumber Pembiayaan',
		deleteTitle: 'Hapus Biaya',
		type: 'Tipe',
		product: 'Produk',
		description: 'Note',
		date: 'Tanggal Pengeluaran',
		created_at: 'Dibuat Pada',
		fb: {
			integrate: 'Integrasi Akun Facebook',
			empty:
				'Integrasikan akun Facebook anda untuk menghitung biaya iklan facebook secara otomatis',
		},
		empty: {
			filter: 'Anda tidak memiliki pembiayaan di tanggal ini.',
			data: 'Tidak ada pembiayaan',
		},
		deleteConfirm: 'Apakah anda yakin ingin menghapus',
		filterTitle: 'Filter Pembiayaan',
		filterDate: 'Tanggal Pembiayaan',
		filterDateSince: 'Tanggal Mulai',
		filterDateUntil: 'Tanggal Berakhir',
		tag: 'Tags',
		maxSelectedTag: 'Kamu hanya boleh memasukkan maximal 5 tag',
		tagCreate: 'Tambah Tag',
		setTag: 'Atur Tag',
		amaount: 'Jumlah',
		note: 'Catatan',
		validate: {
			name: 'Nama wajib diisi !',
			amount: 'Jumlah wajib diisi !',
			product: 'Silahkan pilih produk',
			adAccount: 'Silahkan pilih ad account',
			campaign: 'Silahkan pilih campaign',
		},
		titleSource: 'List Pengeluaran Otomatis',
		createSourceLink: 'List Pengeluaran Otomatis',
		createSource: 'Pengeluaran Otomatis',
		source: 'Sumber',
		emptySource: 'Tidak ada hasil',
		adAccount: 'Ad Account',
		adAccountName: 'Ad Account Name',
		emptyAdAccount: 'Tidak ada ad account',
		campaign: 'Campaign',
		campaignName: 'Campaign Name',
		emptyCampaign: 'Tidak ada campaign',
		loadMore: 'Muat lagi ...',
		includeTax: 'Include TAX',
		includePpn: 'Include PPN',
	},
	reminder: {
		mainTitle: 'Pengingat',
		link: 'Pengingat',
		create: 'Buat Pengingat',
		createNote: 'Tambah Catatan',
		sendMessage: 'Kirim Pesan',
		sendEmail: 'Kirim Email',
		sendSMS: 'Kirim SMS',
		sendWhatsapp: 'Kirim Whatsapp',
		add: 'Tambah Pengingat',
		maxSelectedWa: 'Pengiriman Pesan Whatsapp Maksimal 50 Kontak',
		date: 'Tanggal',
		title: 'Title',
		desc: 'Deskripsi',
		name: 'Nama',
		phone: 'NoHp',
		email: 'Email',
		lastContacted: 'Dikontak Terakhir',
		empty: {
			data: 'Tidak Ada Pengingat',
			filter: 'Kamu Tidak Memiliki Pengingat Di Tanggal Ini.',
		},
	},
	product: {
		add: 'Tambah Produk',
		empty: 'Produk tidak ditemukan',
	},
	profile: {
		changePassword: 'Ganti password',
		saveProfile: 'Simpan profil saya',
		emailInfo: 'digunakan untuk Login',
		changeEmail: 'Ganti Email',
		newEmail: 'Email Baru',
		changePhoneNumber: 'Ganti Nomor Telepon',
		submit: 'Submit',
	},
	barcode: {
		label: 'Barcode Value',
		orderId: 'ID Pesanan',
		number: 'No.',
		name: 'Nama',
		status: 'Status',
		receipt: 'Receipt',
		noReceipt: 'Scan Without Receipt ',
		withReceipt: 'Scan With Receipt',
		empty:
			'Scan your shipping label barcode to start updating order status to Completed',
		emptyReceipt:
			'Scan your shipping label and receipt number barcode to start updating order status to Completed',
		bactToOrder: 'Kembali ke Halaman Order',
	},
	members: {
		schedule: {
			status: 'Status',
			day: 'Hari',
			start: 'Jam Masuk',
			end: 'Jam Keluar',
		},
	},
	resellers: {
		manual_register: 'Tambah Manual',
		register_link: 'Daftar di Storefront',
		back_to_reseller: 'Kembali ke Reseller',
		pending: 'Menunggu Aktivasi',
		enable_register: 'Izinkan pengunjung membuat akun reseller di Toko',
		csv_example: 'Unduh Contoh File CSV',
		tier: {
			name: 'Reseller Tier',
			list: 'List Tier',
			deleteTitle: 'Hapus Tier Reseller',
			discount_type: 'Tipe Diskon',
			discount_value: 'Nominal Diskon',
			create: 'Tambah Tier Baru',
			addModalTitle: 'Buat Tier Baru',
			editModalTitle: 'Ubah Tier',
			deleteConfirm: 'Anda yakin akan mengapus ',
			action: {
				edit: 'Edit',
				detail: 'Detail',
			},
			empty: {
				filter: 'Data tidak ditemukan',
				data: 'Tidak ada data',
			},
			threshold_type: 'Tipe Ambang Batas',
			threshold_value: 'Nilai Ambang Batas',
			level: 'Level',
			discount_max: 'Maximum Diskon',
			validate: {
				name: 'Nama tidak boleh kosong',
				discount_type: 'Tipe Diskon tidak boleh kosong',
				discount_value: 'Nominal Diskon tidak boleh kosong',
				auto_upgrade: 'Auto Upgrade',
				threshold_type: 'Tipe ambang batas tidak boleh kosong',
				threshold_value: 'Nilai ambang batas tidak boleh kosong',
				level: 'Level {level} sudah ada',
				empty: 'Tier belum dibuat. silahkan buat Tier terlebih dahulu sebelum membuat reseller',
			},
			auto_upgrade: 'Auto Upgrade',
			threshold_types: {
				transaction: 'Total Transaksi',
				revenue: 'Total Pendapatan',
				not_set: 'Tidak ada',
				quantity: 'Total Kuantitas',
			},
			placeholder: 'Pilih Tier',
		},
		reward: {
			name: 'Reseller Hadiah',
			list: 'List hadiah',
			deleteTitle: 'Hapus Hadiah Reseller',
			create: 'Tambah Hadiah Baru',
			addModalTitle: 'Buat Hadiah Baru',
			editModalTitle: 'Ubah Hadiah',
			deleteConfirm: 'Anda yakin akan mengapus ',
			point: 'Poin',
			status: 'Status',
			type: 'Tipe',
			action: {
				edit: 'Edit',
				detail: 'Detail',
			},
			empty: {
				filter: 'Data tidak ditemukan',
				data: 'Tidak ada data',
			},
			validate: {
				name: 'Nama tidak boleh kosong',
			},
			placeholder: 'Pilih Hadiah',
			request: 'Permintaan Hadiah',
		},

		exchange: {
			pending: 'Tandai sbg. Pending',
			process: 'Tandai sbg. Process',
			complete: 'Tandai sbg. Complete',
			refund: 'Tandai sbg. Refund',
			cancel: 'Tandai sbg. Cancel',
		},
		limit: 'Reseller anda sudah mencapai batas. tingkatkan plan and. reseller: {count}/{limit}',
		list: 'List Reseller',
		create: 'Tambah Reseller',
		name: 'Nama',
		email: 'Email',
		total_commission: 'Total Komisi',
		total_reseller_margin: 'Total Margin',
		phone: 'Telpon',
		revenue: 'Pendapatan',
		action: {
			edit: 'Edit',
			detail: 'Detail',
			accept: 'Terima',
			pending: 'Tunda',
			delete: 'Hapus',
			permanent_delete: 'Hapus Selamanya',
		},
		title: 'Resellers',
		source_type: 'Type',
		addModalTitle: 'Tambah Reseller',
		editModalTitle: 'Edit Reseller',
		upload: 'Upload Reseller',
		deleteConfirm: 'Anda yakin akan menghapus data ini ?',
		deleteTitle: 'Hapus Reseller',
		sales_quantity: 'Qty',
		total_price: 'Total Penjualan',
		orders: 'Order',
		paid: 'Paid',
		enable_local_commission_type: 'Gunakan pengaturan tipe komisi khusus untuk produk ini',
		enable_local_reseller_product_tier: 'Gunakan pengaturan Tier khusus untuk produk ini',
		type_placeholder: 'Pilih jenis komisi',
		settings: {
			title: 'Pengaturan Reseller',
			commission_type: 'Jenis Komisi',
			reseller_tier: 'Reseller Tier',
			discount: 'Diskon',
			commission: 'Komisi',
		},
		filterReseller: 'Filter Reseller',
		alert: {
			bulkTier: 'Perhatian, pengaturan ini akan merubah tier dari reseller yang dipilih.',
		},
	},
	tickets: {
		create: 'Buat Tiket',
		filterTitle: 'Filter Tiket',
		subject: 'Subjek',
		message: 'Pesan',
		type: 'Tipe',
		topic: 'Topik',
		status: 'Status',
		priority: 'Prioritas',
		created_at: 'Dibuat Pada',
		empty: {
			filter: 'Anda tidak memiliki tiket bantuan di tanggal ini.',
			data: 'Tidak ada tiket bantuan',
		},
		detail: 'Tiket Detail',
		id: 'Tiket ID',
		reply: 'Balas',
	},
	'Yes': 'Ya',
	'Cancel': 'Batal',
	'Save': 'Simpan',
	'Close': 'Tutup',
	'Notifications': 'Notifikasi',
	'Select': 'Pilih',
	'Max. 5 notifications per product': 'Maks. 5 notifikasi per produk',
	'Phone number cannot be empty': 'No. telepon tidak boleh kosong',
	'Edit Profile': 'Edit Profil',
	'Devices': 'Perangkat',
	'Sorry, username is not available': 'Maaf, username tidak tersedia',
	'Team Member': 'Anggota Tim',
	'Orders': 'Pesanan',
	'Products': 'Produk',
	'Your Credits': 'Kredit Anda',
	'Active Until': 'Aktif Sampai',
	'Change Password': 'Ubah Password',
	'New Password': 'Password Baru',
	'Confirm New Password': 'Konfirmasi Password Baru',
	'Password is minimal 6 character': 'Password minimal 6 karakter',
	'New Password not match': 'Password baru tidak cocok',
	'Remove Device': 'Hapus Perangkat',
	'Logout the selected device?': 'Keluarkan perangkat terpilih?',
	'Logout this device': 'Keluarkan perangkat ini',
	'Change Profile Picture': 'Ganti Gambar Profil',
	'Your Email Address': 'Alamat Email Anda',
	'Reset Password': 'Atur Ulang Password',
	'Back to Login': 'Kembali ke Login',
	'Please Check Your Email': 'Mohon cek email anda',
	'If your email is registered in Ostock.id, you will receive a link to reset your password in your email inbox': 'Anda akan menerima link untuk mengatur ulang password di email anda, jika email anda sudah terdaftar di Ostock.id',
	'Forgot Password': 'Lupa Password',
	'Sign in': 'Masuk',
	'OK, I Understand': 'OK, Saya Mengerti',
	'Print Shipping Label': 'Cetak Label Pengiriman',
	'Save Config': 'Simpan Pengaturan',
	'Total rates must be greater than 0': 'Jumlah total pembagian harus lebih besar dari 0',
	'Billings': 'Tagihan',
	'No Notifications': 'Tidak ada notifikasi',
	'Show All Notifications': 'Lihat Semua Notifikasi',
	'Email Notifications': 'Notifikasi Email',
	'No Notifications selected yet': 'Belum ada notifikasi yang dipilih',
	'What\'s New': 'Yang Terbaru',
	'Profile': 'Profil',
	'Can be changed later in Profile Settings': 'Dapat diubah nanti di Pengaturan Profil',
	'Define your username to identify your products': 'Tentukan username Anda untuk mengidentifikasi produk Anda',
	'Create Username': 'Buat Username',
	'Welcome': 'Selamat Datang',
	'Username is available': 'Username tersedia',
	'Checking availability': 'Mengecek ketersediaan',
	'Step 1 of 3': 'Langkah 1 dari 3',
	'Step 2 of 3': 'Langkah 2 dari 3',
	'Step 3 of 3': 'Langkah 3 dari 3',
	'Next': 'Selanjutnya',
	'Add Bank Accounts': 'Tambahkan No. Rekening',
	'Add Bank Account': 'Tambah No. Rekening',
	'Will be shown when customer success submitting an order': 'Akan dimunculkan saat pembeli selesai mengisi form',
	'Can be changed later in Store Settings': 'Dapat diubah nanti di Pengaturan Toko',
	'Tutorials': 'Tutorial',
	'Know more about Ostock, Check out the': 'Cari tahu lebih lanjut tentang Ostock, di',
	'Get Started': 'Memulai',
	'Done': 'Selesai',
	'You can edit integrations later in Settings menu': 'Anda dapat mengubah integrasi di menu Pengaturan',
	'Finish': 'Selesai',
	'Mark All as Read': 'Tandai sudah dibaca',
	'Transaction': 'Transaksi',
	'Revenue': 'Pendapatan',
	'Profitable Products': 'Produk Yang Menguntungkan',
	'High Demand Products': 'Produk Permintaan Tertinggi',
	'High Converting Products': 'Produk dengan Penjualan Tertinggi',
	'Total Orders': 'Total Order',
	'Total Paid': 'Total Bayar',
	'Paid Ratio': 'Rasio Bayar',
	'Unpaid Orders': 'Order Belum Dibayar',
	'Processed and Completed Orders that is Unpaid': 'Pesanan yang Diproses dan Selesai yang Belum Dibayar',
	'Bump Order': 'Bump Order',
	'Bump Revenue': 'Pendapatan Bump',
	'Discount Claimed': 'Diskon Diklaim',
	'Shipping Cost': 'Ongkir',
	'Total Quantity Sold': 'Jumlah Item Terjual',
	'COGS': 'HPP',
	'Unpaid Revenue': 'Pendapatan Belum Terbayar',
	'Gross Revenue': 'Pendapatan Kotor',
	'Net Revenue': 'Pendapatan Bersih',
	'Gross Profit': 'Keuntungan Kotor',
	'Net Profit': 'Keuntungan Bersih',
	'Expenses': 'Pengeluaran',
	'Net Revenue = Gross Revenue - (Shipping Cost - Shipping Cost Discount)': 'Pendapatan Bersih = Pendapatan Kotor - (Ongkir - Diskon Ongkir)',
	'Gross Profit = Net Revenue - COGS': 'Keuntungan Kotor = Pendapatan Bersih - HPP',
	'Net Profit = Gross Profit - Expense': 'Keuntungan Bersih = Keuntungan Kotor - Pengeluaran',
	'Hello': 'Halo',
	'Paid': 'Sudah Dibayar',
	'Transaction Details': 'Detail Transaksi',
	'No Transaction Details': 'Tidak Ada Detail Transaksi',
	'Total Products': 'Total Produk',
	'Total Paid Order': 'Total Order Dibayar',
	'Delete': 'Hapus',
	'Actions': 'Tindakan',
	'Export': 'Ekspor',
	'Import': 'Impor',
	'Follow-Up Text': 'Teks Follow-up',
	'Assignation': 'Penugasan',
	'Trackings': 'Trackings',
	'Selected Products': 'Produk Terpilih',
	'Search': 'Cari',
	'Click here to Refresh': 'Klik di sini untuk refresh',
	'Request Pickup': 'Request Pickup',
	'Pickup Date': 'Tanggal Pickup',
	'Pickup Time': 'Waktu Pickup',
	'Drop Date': 'Tanggal Drop',
	'Drop Time': 'Waktu Drop',
	'Address is required': 'Alamat wajib diisi',
	'Pickup Location Address': 'Alamat Lokasi Pickup',
	'Phone Number': 'Nomor Telepon',
	'Phone is required': 'No. telepon wajib diisi',
	'Courier': 'Kurir',
	'Selected Orders': 'Order Terpilih',
	'Remove from Selected Orders': 'Hapus dari Order Terpilih',
	'Name': 'Nama',
	'Qty Sold': 'Jumlah Terjual',
	'Duplicate': 'Duplikat',
	'Delete Product': 'Hapus Produk',
	'Are you sure want to delete': 'Anda yakin ingin menghapus',
	'products': 'produk',
	'All': 'Semua',
	'orders': 'pesanan',
	'from these products will be deleted too': 'dari produk ini akan ikut terhapus',
	'Products to be deleted': 'Produk yang akan terhapus',
	'Confirm Delete': 'Konfirmasi Hapus',
	'Price': 'Harga',
	'Handled By': 'Ditugaskan untuk',
	'Shipping Courier can\'t be edited when Smart Logistic is activated': 'Anda tidak dapat merubah ekspedisi untuk pesanan yang menggunakan Smart Logistic',
	'Shipping Estimate': 'Estimasi Ongkir',
	'COD Fee': 'Biaya COD',
	'Shipping': 'Pengiriman',
	dropship: {
		add: 'Tambah Produk',
		sell: 'Jual Produk',
	},
	'Start Here': 'Mulai Dari Sini',
	'Types of Product': 'Jenis Produk Yang Diminati',
	'Product Description': 'Deskripsi Produk',
	'Product Specification': 'Spesifikasi Produk',
	'Examples of Product Photos': 'Contoh Foto Produk',
	'Product Reference Link': 'Link Referensi Produk',
	'What is your average sales amount per month?': 'Berapa rata-rata jumlah penjualan Anda per bulan?',
	'Data can only be edited when in \'review\' status': 'Data hanya dapat diedit bila dalam status \'review\'',
	'Product Type': 'Jenis Produk',
	'Product Images': 'Foto Produk',
	'Product Link': 'Link Produk',
	'Sales': 'Penjualan',
	'Seller Data': 'Data Seller',
	'Contact': 'Kontak',
	'Add': 'Tambah',
	'Update': 'Perbarui',
	'Remove': 'Hapus',
	'Wholesale Prices': 'Harga Grosir',
	'Add / Edit Wholesale Price': 'Tambah / Edit Harga Grosir',
	'Min. Quantity': 'Jumlah Minimal',
	'Normal Price': 'Harga Normal',
	'Commission': 'Komisi',
	'Margin': 'Margin',
	'Recommended Price': 'Harga Rekomendasi',
	'Changes': 'Perubahan',
	'Edit': 'Ubah',
	'Please be aware, that this update will affected to added product in Orderonline.': 'Perlu diketahui, bahwa pembaruan ini akan mempengaruhi produk yang sudah ditambahkan di Orderonline.',
	'Show Marketing Kit': 'Tampilkan Marketing Kit',
	'Description': 'Deskripsi',
	'Variation Code': 'Kode Varian',
	'Address': 'Alamat',
	'Save Address': 'Simpan Alamat',
	'Return at': 'Dikembalikan pada',
	'Apply filter': 'Terapkan filter',
	'Unable to display products, click to see terms & conditions': 'Tidak dapat menampilkan produk, klik untuk lihat syarat & ketentuan',
	'Login to view product': 'Login untuk melihat produk',
	'Type': 'Tipe',
	'Private Order Feature': 'Fitur Order Grosir',
};

export default messages;
